module.exports = __webpack_public_path__ + "static/media/whale.5c447f44.png";